var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"iframe_wrap"},[_c('iframe',{ref:"iframe",staticClass:"iframeVideo",attrs:{"width":_vm.width,"height":_vm.height,"scrolling":"no"}})])}
var staticRenderFns = []

export { render, staticRenderFns }